import React, { useMemo } from "react";
import { Typography } from "@mui/material";
import ResponsiveDrawer from "views/components/ResponsiveDrawer";
import { MaterialReactTable } from "material-react-table";
import AllSyoyakuData from "data/all-syoyaku.json";

function AllSyoyaku() {
  const columns = useMemo(
    () => [
      {
        accessorKey: "name",
        header: "名前",
      },
    ],
    []
  );

  return (
    <ResponsiveDrawer>
      <div style={{ maxWidth: "calc(100vw - 48px)" }}>
        <MaterialReactTable
          columns={columns}
          data={AllSyoyakuData}
          enableColumnFilterModes
          enableColumnOrdering
          enableGrouping
          enablePinning
          enableRowSelection={false}
          initialState={{ density: "compact" }}
          renderTopToolbarCustomActions={() => (
            <Typography paragraph style={{ margin: 0 }}>生薬</Typography>
          )}
        />
      </div>
    </ResponsiveDrawer>
  );
}

export default AllSyoyaku;
